import { Button, TextArea, TextInput } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import { useComponentParams } from 'components/SalaryComponents/hooks';
import { nonPayableBenefitsGeneralDetailsStepValidationSchema } from 'components/WizardViews/SalaryComponents/constants';
import { NonPayableBenefitsFormData } from 'components/WizardViews/SalaryComponents/types';
import {
  FieldGroup,
  FormWrapper,
  StepActionsWrapper,
  StepContentWrapper,
  StepHeader,
} from 'components/WizardViews/components';
import { useFormWithProvider } from 'forms';
import { FormEvent, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

const GeneralDetailsStep = () => {
  const { validate, register } = useFormWithProvider<NonPayableBenefitsFormData>();
  const history = useHistory();
  const { searchString } = useComponentParams();

  const isFormValid = useMemo(
    () => validate(nonPayableBenefitsGeneralDetailsStepValidationSchema, { sideEffects: false }),
    [validate],
  );

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (validate(nonPayableBenefitsGeneralDetailsStepValidationSchema)) {
      history.push({
        pathname: routePaths.salaryComponents.create.nonPayableBenefits.review,
        search: searchString,
      });
    }
  };

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <StepContentWrapper>
        <StepHeader title="General" subtitle="Configuration" marginBottom={'spacing.9'} />

        <FieldGroup title="General details">
          <TextInput
            label="Component name"
            placeholder="Enter component name"
            {...register('name')}
            isRequired
          />

          <TextInput
            label="Display name in payslip & Salary Register"
            placeholder="Enter display name"
            helpText="Display will be used in employee payslip and salary register"
            {...register('displayName')}
            isRequired
          />

          <TextArea
            label="Component description"
            placeholder="Enter description"
            {...register('description')}
          />
        </FieldGroup>
      </StepContentWrapper>

      <StepActionsWrapper>
        <span />
        <Button type="submit" isDisabled={!isFormValid}>
          Review
        </Button>
      </StepActionsWrapper>
    </FormWrapper>
  );
};

export default GeneralDetailsStep;
